module.exports = __webpack_public_path__ + "static/media/rm_06-15.fa45a7d7.png";